import "./AmSecurity.scss";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import newRequest from '../../../utils/newRequest';
import { GridLoader, ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { MdAdd, MdClose, MdDelete, MdDragIndicator, MdEmail, MdOutlineNumbers, MdPhone, MdSave, } from 'react-icons/md';
import { IoClose, IoDocumentTextSharp } from 'react-icons/io5';
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import app from "../../../utils/firebase";
import moment from "moment";
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
} from "firebase/storage";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import {
    Table,
    TablePagination,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@mui/material";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { IoIosRefresh } from "react-icons/io";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent";
import { showToast } from "../../../toastService";
import { fetchClientsBySearch, formatAmountsToDecimals, formatNumber, formatStringToNumberV2, getFirstName } from "../../../utils/genericFunctions";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import { CiImageOn } from "react-icons/ci";
import UploadDialog from "../../../components/uploadDialog/UploadDialog";
import { TbCertificate } from "react-icons/tb";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages";
import { useTranslation } from "react-i18next";

const AmSecurity = () => {
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const navigate = useNavigate();
    const { docid } = useParams();
    const [securityDocId, setSecurityDocId] = useState(null);
    const [securityData, setSecurityData] = useState(null);
    const [securityTypes, setSecurityTypes] = useState([]);
    const [dataSources, setDataSources] = useState([]);
    const [investorTypes, setInvestorTypes] = useState([]);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [saveEnabled, setSaveEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Activate");
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [selectedExchange, setSelectedExchange] = useState(null);
    const [selectedIssuer, setSelectedIssuer] = useState(null);
    const [selectedAgency, setSelectedAgency] = useState(null);
    const [selectedGrade, setSelectedGrade] = useState(null);
    const [agencyRatings, setAgencyRatings] = useState([]);
    const [traceData, setTraceData] = useState([]);
    const agencyRef = useRef(null);
    const [currencies, setCurrencies] = useState([]);
    const [definedRegions, setDefinedRegions] = useState([]);
    const [definedSectors, setDefinedSectors] = useState([]);
    const [definedSubSectors, setDefinedSubSectors] = useState([]);
    const [validationMsgDialog, setValidationMsgDialog] = useState(false);
    const [validationMessagesResult, setValidationMessagesResult] = useState({});
    const [assetClasses, setAssetClasses] = useState([]);
    const [securityRatings, setSecurityRatings] = useState([]);

    const [valuationMethods, setValuationMethods] = useState([]);
    const [listingStatus, setListingStatus] = useState([]);

    const [securityRateTypes, setSecurityRateTypes] = useState([]);
    const [frequencies, setFrequencies] = useState([]);
    const [securityRateFrequencies, setSecurityRateFrequencies] = useState([]);
    const [securityRateApplOn, setSecurityRateApplOn] = useState([]);
    const [triggerConditions, setTriggerConditions] = useState([]);
    const [regions, setRiskProfiles] = useState([]);
    const [rebalanceMethods, setRebalanceMethods] = useState([]);

    // firebase uploads
    const [img, setImg] = useState(undefined);
    const [imgPerc, setImgPerc] = useState(0);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [file, setFile] = useState(null);


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "Activate") {
                let validateResponse = null;
                try {
                    validateResponse = await newRequest.get(`/amsec/validate/${securityDocId}`, { timeout: 5000 });
                } catch (error) {
                    if (error.code === 'ECONNABORTED') {
                        console.error("Request timed out!");
                        showToast(t('requestTimedOut'), "error");
                    } else {
                        console.error("Other error:", error.message);
                        showToast(error.message, "error");
                    }
                }
                if (validateResponse.data.result_status === "error") {
                    setIsProcessing(false);
                    setIsConfirmDialogOpen(false);
                    setValidationMessagesResult(validateResponse.data);
                    setValidationMsgDialog(true);
                    return;
                }
                const res = await newRequest.put(`/amsec/upd/${securityDocId}`, { sec_status: "Active" }, { timeout: 5000 });
                await fetchSecurity(securityDocId, true);
                showToast(t('securityActivated', { param1: securityData?.sec_name }), "success");
            } else if (confirmDialogAction === "Pause") {
                const res = await newRequest.put(`/amsec/upd/${securityDocId}`, { sec_status: "Paused" }, { timeout: 5000 });
                await fetchSecurity(securityDocId, true);
                showToast(t('securityPaused', { param1: securityData?.sec_name }), "success");
            }
        } catch (err) {
            console.log(err);
        }
        setIsConfirmDialogOpen(false);
    };


    const fetchCurrencies = async () => {
        try {
            const res = await newRequest.get("/glCurrency/findAll");
            const options = res.data.map((currency) => ({
                value: currency?.cur_code,
                label: currency?.cur_code,
            }));
            setCurrencies(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchAgencyRatings = async (entityDocid) => {
        try {
            if (entityDocid) {
                const res = await newRequest.get(`/allEntity/ratings/${entityDocid}`);
                const options = res.data.map((val) => ({
                    meaning: val?.meaning,
                    grade: val?.grade,
                    value: val?.rate,
                    label: val?.rate,
                }));
                setAgencyRatings(options);
            }
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    useEffect(() => {
        img && uploadToFirebase(img, "am_security");
    }, [img]);


    // get ratings for selected agency
    useEffect(() => {
        fetchAgencyRatings(selectedAgency?.ent_docid);
    }, [selectedAgency]);

    const uploadToFirebase = async (file, fileFolder) => {
        setIsDialogOpen(true);
        const storage = getStorage(app);
        const fileName = new Date().getTime() + file.name;
        const fileExtension = file.name.split(".").pop(); // Get file extension
        const fileType = file.type; // Get file type
        const fileSizeKB = file.size / 1024; // Get file size in KB
        const storageRef = ref(
            storage,
            `qc_${currentUser.usr_org_code}/${fileFolder}/${fileName}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress(Math.round(progress));
                switch (snapshot.state) {
                    case "paused":
                        console.log("Upload is paused");
                        break;
                    case "running":
                        console.log("Upload is running");
                        break;
                    default:
                        break;
                }
            },
            (error) => {
                setIsDialogOpen(false);
                console.log(error);
            },
            async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                try {
                    const res = await newRequest.put(`/amsec/upd/${securityData?._id}`, { sec_logo_url: downloadURL });
                    handleSetSecurityData("sec_logo_url", downloadURL);
                    setIsDialogOpen(false);
                } catch (error) {
                    console.log(error);
                    setIsDialogOpen(false);
                }

            }
        );
    };


    const saveRecord = async (e) => {
        try {
            // check rebalancing rule
            // if (securityData?.rebalance_method === 'Threshold-Based' && parseFloat(formatStringToNumberV2(securityData?.rebalance_threshold || 0)) === 0) {
            //     setNotifyDialogTitle(t('error'));
            //     setNotifyDialogText(`${t('rebalancingRuleError', { method: securityData?.rebalance_method })}`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }

            // const formattedFees = fees?.map(line => ({
            //     ...line,
            //     rate: parseFloat(formatStringToNumberV2(line?.rate, 2)),
            // }));

            // // console.log(`formattedFees ${JSON.stringify(formattedFees, null, 2)}`);

            // // update security info
            const formattedData = {
                ...securityData,
                sec_ratings: securityRatings,
                exchange_docid: selectedExchange?.ent_docid,
                exchange_ent: selectedExchange?.value,
                issuer_docid: selectedIssuer?.ent_docid,
                issuer_ent: selectedIssuer?.value,
                latest_market_price: parseFloat(formatStringToNumberV2(securityData?.latest_market_price || 0)),
                face_value: parseFloat(formatStringToNumberV2(securityData?.face_value || 0)),
                coupon_rate: parseFloat(formatStringToNumberV2(securityData?.coupon_rate || 0, 6)),
            };
            const res = await newRequest.put(`/amsec/upd/${securityData?._id}`, { ...formattedData });
            setNotifyDialogTitle(t('success'));
            setNotifyDialogText(t('successSaved', { param1: securityData?.sec_name }));
            setIsNotifyDialogOpen(true);
        } catch (err) {
            console.log(err);
        }
    };

    const handleSetSecurityData = (name, value) => {
        setSecurityData((prev) => {
            return { ...prev, [name]: value };
        });
    };

    const fetchSecurity = async (doc_id, firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            }
            const res = await newRequest.get(`/amsec/find/${doc_id}`);
            if (res.data) {

                const formattedData = {
                    ...res.data,
                    latest_market_price: formatAmountsToDecimals(res.data?.latest_market_price || 0),
                    face_value: formatAmountsToDecimals(res.data?.face_value || 0),
                    coupon_rate: formatAmountsToDecimals(res.data?.coupon_rate || 0, 6),
                    last_synced_at: res.data?.last_synced_at ? moment(res.data?.last_synced_at).format("YYYY-MM-DD") : null,
                    issue_date: res.data?.last_synced_at ? moment(res.data?.issue_date).format("YYYY-MM-DD") : null,
                    maturity_date: res.data?.last_synced_at ? moment(res.data?.maturity_date).format("YYYY-MM-DD") : null,
                };
                setSecurityData(formattedData);
                setSecurityDocId(res.data?._id);
                setDocumentEnabled(res.data?.document_enabled_xx);
                setSaveEnabled(res.data?.save_enabled_xx);
                setNextAction(res.data?.next_action_xx);
                setSecurityRatings(res.data?.sec_ratings);
                await fetchTrace(res.data?.sec_code);

                if (res.data?.exchange_xx) {
                    setSelectedExchange({
                        ent_docid: res.data?.exchange_xx?._id,
                        ent_email: res.data?.exchange_xx?.ent_email,
                        ent_phone_no: res.data?.exchange_xx?.ent_phone_no,
                        ent_photo_url: res.data?.exchange_xx?.ent_photo_url,
                        ent_status: res.data?.exchange_xx?.ent_status,
                        aent_name_xx: res.data?.exchange_xx?.aent_name_xx,
                        ent_code: res.data?.exchange_xx?.ent_code,
                        ent_aent_code: res.data?.exchange_xx?.ent_aent_code,
                        ent_name: res.data?.exchange_xx?.ent_name,
                        value: res.data?.exchange_xx?.ent_code,
                        label: (
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                {res.data?.exchange_xx?.ent_name}
                            </div>
                        ),
                    });
                } else {
                    setSelectedExchange(null);
                }


                if (res.data?.issuer_xx) {
                    setSelectedIssuer({
                        ent_docid: res.data?.issuer_xx?._id,
                        ent_email: res.data?.issuer_xx?.ent_email,
                        ent_phone_no: res.data?.issuer_xx?.ent_phone_no,
                        ent_photo_url: res.data?.issuer_xx?.ent_photo_url,
                        ent_status: res.data?.issuer_xx?.ent_status,
                        aent_name_xx: res.data?.issuer_xx?.aent_name_xx,
                        ent_code: res.data?.issuer_xx?.ent_code,
                        ent_aent_code: res.data?.issuer_xx?.ent_aent_code,
                        ent_name: res.data?.issuer_xx?.ent_name,
                        value: res.data?.issuer_xx?.ent_code,
                        label: (
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                {res.data?.issuer_xx?.ent_name}
                            </div>
                        ),
                    });
                } else {
                    setSelectedIssuer(null);
                }

                if (res.data?.document_enabled_xx === "Y") {
                    await callDetailsFunction();
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };

    const callDetailsFunction = async () => {
        try {
            await fetchCurrencies();
            await fetchSecurityTypes();
            await fetchAssetClasses();
            await fetchDefinedSectors();
            await fetchDefinedRegions();
            await fetchDetails();
            await fetchDataSources();
        } catch (err) {
            console.log(err);
        }
    };

    const fetchSecurityTypes = async () => {
        try {
            const res = await newRequest.post(
                "/sysCode/findAll", { sys_type: "Security Types" }
            );
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_code,
            }));

            setSecurityTypes(options);
        } catch (error) {
            console.error("Error fetching security types :", error);
        }
    };

    const fetchAssetClasses = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Asset Classes" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setAssetClasses(options);
        } catch (error) {
            console.error("Error fetching security types :", error);
        }
    };


    const fetchDefinedRegions = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Fund Regions" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));

            setDefinedRegions(options);
        } catch (error) {
            console.error("Error fetching security types :", error);
        }
    };

    const fetchDefinedSectors = async () => {
        try {
            const res = await newRequest.post(
                "/sysCode/findNullGrp", { sys_type: "AM Sectors" }
            );
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));

            setDefinedSectors(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchTrace = async (securityCode) => {
        try {
            const res = await newRequest.post(
                "/trace/findDoc",
                {
                    trc_doc_type: "AM Security",
                    trc_doc_no: securityCode
                }
            );
            setTraceData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchDefinedSubSectors = async (sectorCode) => {
        try {
            const res = await newRequest.post("/sysCode/findGrp", { sys_type: "AM Sectors", sys_grouping: sectorCode });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            console.log(`setDefinedSubSectors ${JSON.stringify(options, null, 2)}`);
            setDefinedSubSectors(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchDataSources = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "AM Data Sources" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_code,
            }));

            setDataSources(options);
        } catch (error) {
            console.error("Error fetching security types :", error);
        }
    };

    const fetchDetails = async () => {
        try {

            const rateTypes = ['Percentage', 'Fixed Amount']?.map((code) => ({
                value: code,
                label: code,
            }));
            setSecurityRateTypes(rateTypes);

            const freqs = ['Annual', 'Quarterly', 'Monthly', 'Weekly', 'Daily']?.map((code) => ({
                value: code,
                label: code,
            }));

            setFrequencies(freqs);

            const rateAt = [
                ...freqs,
                { value: 'Per Transaction', label: 'Per Transaction' }
            ];
            setSecurityRateFrequencies(rateAt);

            const ratesOn = ['AUM', 'NAV', 'Gain', 'Transaction Amount']?.map((code) => ({
                value: code,
                label: code,
            }));
            setSecurityRateApplOn(ratesOn);

            const triggerConds = ["On Subscription", "On Redemption", "On Switch", "On Gain", "On Loss", 'On EOD', 'On EOW', 'On EOM', 'On EOQ', 'On EOY']?.map((code) => ({
                value: code,
                label: code,
            }));
            setTriggerConditions(triggerConds);

            const rebalanceMethods = ['Threshold-Based', 'Calendar-Based']?.map((code) => ({
                value: code,
                label: code,
            }));
            setRebalanceMethods(rebalanceMethods);


            const profiles = ['Low', 'Moderate', 'High']?.map((code) => ({
                value: code,
                label: code,
            }));
            setRiskProfiles(profiles);

            const valuationMethods = ['Market Price', 'Amortized Cost', 'Fair Value Estimate']?.map((code) => ({
                value: code,
                label: code,
            }));
            setValuationMethods(valuationMethods);

            const listing = ['Listed', 'Unlisted', 'Private']?.map((code) => ({
                value: code,
                label: code,
            }));
            setListingStatus(listing);

        } catch (error) {
            console.error("Error :", error);
        }
    };

    // refresh sub sectors based on sector
    useEffect(() => {
        fetchDefinedSubSectors(securityData?.sector_code);
    }, [securityData?.sector_code]);

    useEffect(() => {
        if (docid === "new" || docid === undefined) {
            setDocumentEnabled("Y");
            callDetailsFunction();
        } else {
            fetchSecurity(docid, true);
        }

    }, [docid]);


    return (
        <motion.div
            className="am-security"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="am-security-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <span className="main-title"> {securityData?.sec_name}</span>
                            <span className="sub-title"> {securityData?._id}</span>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="left"
                                endIcon={<IoIosRefresh />}
                                onClick={async () => {
                                    try {
                                        await fetchSecurity(securityDocId);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >
                                {t('refresh')}
                            </CustomLoadingButton>
                            {nextAction !== "None" &&
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdDragIndicator />}
                                    onClick={() => {
                                        setConfirmationActiontext(`Do you want to ${nextAction} this security?`);
                                        setConfirmDialogAction(nextAction);
                                        setIsConfirmDialogOpen(true);
                                    }}
                                >
                                    {t(nextAction)}
                                </CustomLoadingButton>}
                            {saveEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {securityDocId !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="right"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="main-content-wrapper">
                        <div className="security-wrapper">
                            <div className="security-details">
                                <div className="details-view">
                                    <ExpandableComponent
                                        title={t('details').toUpperCase()}
                                        subtitle={<span className={`status ${securityData?.sec_status}`}>{`${t('status').toUpperCase()} ${securityData?.sec_status}`}</span>}
                                        defaultExpanded={true}
                                    >
                                        <div className="row-details">
                                            <div className="row-left" >
                                                <div className="input-item-with-label">
                                                    <label htmlFor="sec_name"
                                                        className="form-input-label"
                                                        style={{ width: "100px" }}>
                                                        {t('name').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="sec_name"
                                                        type="text"
                                                        placeholder={t('name').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        value={securityData?.sec_name}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetSecurityData("sec_name", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                        onBlur={(e) => {
                                                            if (e.target.value && !securityData?.sec_alias) {
                                                                handleSetSecurityData("sec_alias", getFirstName(e.target.value));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="sec_alias"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('alias').toUpperCase()}
                                                        </label>
                                                        <input
                                                            name="sec_alias"
                                                            type="text"
                                                            placeholder={t('alias').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            value={securityData?.sec_alias}
                                                            onChange={(e) => {
                                                                try {
                                                                    handleSetSecurityData("sec_alias", e.target.value);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            disabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="sec_code"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('code').toUpperCase()}
                                                        </label>
                                                        <input
                                                            name="sec_code"
                                                            type="text"
                                                            placeholder={t('code').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            value={securityData?.sec_code}
                                                            onChange={(e) => {
                                                                try {
                                                                    handleSetSecurityData("sec_code", e.target.value);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            disabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="asset_class_code"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('class').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="asset_class_code"
                                                                name="asset_class_code"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={assetClasses.find(option => option.value === securityData?.asset_class_code) || null}
                                                                onChange={selectedOption => handleSetSecurityData("asset_class_code", selectedOption?.value)}
                                                                options={assetClasses}
                                                                isSearchable={true}
                                                                placeholder={t('class')}
                                                                isDisabled={documentEnabled === "N"}
                                                            />
                                                            :
                                                            <input
                                                                name="asset_class_code_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={securityData?.asset_class_code_xx}
                                                                onChange={(e) => handleSetSecurityData("asset_class_code", e.target.value)}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="valuation_method"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('valuation').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="valuation_method"
                                                                name="valuation_method"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={valuationMethods.find(option => option.value === securityData?.valuation_method) || null}
                                                                onChange={selectedOption => handleSetSecurityData("valuation_method", selectedOption?.value)}
                                                                options={valuationMethods}
                                                                isSearchable={true}
                                                                placeholder={t('valuation')}
                                                                isDisabled={documentEnabled === "N"}
                                                            />
                                                            :
                                                            <input
                                                                name="valuation_method_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={securityData?.valuation_method}
                                                                onChange={(e) => handleSetSecurityData("valuation_method", e.target.value)}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="sector_code"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('sector').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="sector_code"
                                                                name="sector_code"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={definedSectors.find(option => option.value === securityData?.sector_code) || null}
                                                                onChange={selectedOption => handleSetSecurityData("sector_code", selectedOption?.value)}
                                                                options={definedSectors}
                                                                isSearchable={true}
                                                                placeholder={t('sector')}
                                                                isDisabled={documentEnabled === "N"}
                                                            />
                                                            :
                                                            <input
                                                                name="sector_code_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={securityData?.sector_code_xx}
                                                                onChange={(e) => handleSetSecurityData("sector_code", e.target.value)}
                                                                disabled={true}
                                                            />}

                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="region_code"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('region').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="region_code"
                                                                name="region_code"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={definedRegions.find(option => option.value === securityData?.region_code) || null}
                                                                onChange={selectedOption => handleSetSecurityData("region_code", selectedOption?.value)}
                                                                options={definedRegions}
                                                                isSearchable={true}
                                                                placeholder={t('region')}
                                                                isDisabled={documentEnabled === "N"}
                                                            /> :
                                                            <input
                                                                name="region_code_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={securityData?.region_code_xx}
                                                                onChange={(e) => handleSetSecurityData("sector_code", e.target.value)}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="sub_sector_code"
                                                            className="form-input-label"
                                                            style={{ width: "85px" }}>
                                                            {t('sub').toUpperCase()}
                                                        </label>
                                                        <Select
                                                            id="sub_sector_code"
                                                            name="sub_sector_code"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="200px"
                                                            value={definedSubSectors.find(option => option.value === securityData?.sub_sector_code) || null}
                                                            onChange={selectedOption => handleSetSecurityData("sub_sector_code", selectedOption?.value)}
                                                            options={definedSubSectors}
                                                            isSearchable={true}
                                                            placeholder={t('sub')}
                                                            isDisabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="data_source"
                                                            className="form-input-label"
                                                            style={{ width: "max-content" }}>
                                                            {t('data').toUpperCase()}
                                                        </label>
                                                        <Select
                                                            id="data_source"
                                                            name="data_source"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="200px"
                                                            value={dataSources.find(option => option.value === securityData?.data_source) || null}
                                                            onChange={selectedOption => handleSetSecurityData("data_source", selectedOption?.value)}
                                                            options={dataSources}
                                                            isSearchable={true}
                                                            placeholder={t('data')}
                                                            isDisabled={documentEnabled === "N"}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="sec_description"
                                                        className="form-input-label"
                                                        style={{ width: "100px", alignSelf: "flex-start" }}>
                                                        {t('desc').toUpperCase()}
                                                    </label>
                                                    <textarea
                                                        name="sec_description"
                                                        type="text"
                                                        rows={3}
                                                        placeholder={t('description').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        value={securityData?.sec_description}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetSecurityData("sec_description", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row-right">
                                                <div className="input-item-with-label">
                                                    <label htmlFor="base_currency"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('currency').toUpperCase()}
                                                    </label>
                                                    {documentEnabled === "Y" ?
                                                        <Select
                                                            id="base_currency"
                                                            name="base_currency"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="150px"
                                                            value={currencies.find(option => option.value === securityData?.base_currency) || null}
                                                            onChange={selectedOption => handleSetSecurityData("base_currency", selectedOption?.value)}
                                                            options={currencies}
                                                            isSearchable={true}
                                                            isDisabled={documentEnabled === "N"}
                                                            placeholder={t('currency').toUpperCase()}
                                                        />
                                                        :
                                                        <input
                                                            id="base_currency_xx"
                                                            name="base_currency_xx"
                                                            type="text"
                                                            placeholder="0.00"
                                                            className="form-input-item"
                                                            style={{ width: "150px" }}
                                                            value={securityData?.base_currency}
                                                            onChange={(e) => handleSetSecurityData("base_currency", e.target.value)}
                                                            disabled={true}
                                                        />}
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="ticker_symbol"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('ticker').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="ticker_symbol"
                                                        type="text"
                                                        placeholder={t('ticker').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "150px" }}
                                                        value={securityData?.ticker_symbol}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetSecurityData("ticker_symbol", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div>

                                                <div className="input-item-with-label">
                                                    <label htmlFor="security_type"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('type').toUpperCase()}
                                                    </label>
                                                    {documentEnabled === "Y" ?
                                                        <Select
                                                            id="security_type"
                                                            name="security_type"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="150px"
                                                            value={securityTypes.find(option => option.value === securityData?.security_type) || null}
                                                            onChange={selectedOption => handleSetSecurityData("security_type", selectedOption?.value)}
                                                            options={securityTypes}
                                                            isSearchable={true}
                                                            placeholder={t('types')}
                                                            isDisabled={documentEnabled === "N"}
                                                        />
                                                        :
                                                        <input
                                                            id="security_type_xx"
                                                            name="security_type_xx"
                                                            type="text"
                                                            className="form-input-item"
                                                            style={{ width: "150px" }}
                                                            value={securityData?.security_type}
                                                            onChange={(e) => handleSetSecurityData("security_type", e.target.value)}
                                                            disabled={true}
                                                        />}
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="listing_status"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('listing').toUpperCase()}
                                                    </label>
                                                    {documentEnabled === "Y" ?
                                                        <Select
                                                            id="listing_status"
                                                            name="listing_status"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="150px"
                                                            value={listingStatus.find(option => option.value === securityData?.listing_status) || null}
                                                            onChange={selectedOption => handleSetSecurityData("listing_status", selectedOption?.value)}
                                                            options={listingStatus}
                                                            isSearchable={true}
                                                            placeholder={t('listing')}
                                                            isDisabled={documentEnabled === "N"}
                                                        />
                                                        :
                                                        <input
                                                            id="listing_status_xx"
                                                            name="listing_status_xx"
                                                            type="text"
                                                            className="form-input-item"
                                                            style={{ width: "150px" }}
                                                            value={securityData?.listing_status}
                                                            onChange={(e) => handleSetSecurityData("listing_status", e.target.value)}
                                                            disabled={true}
                                                        />}
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="isin_code"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('isin').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="isin_code"
                                                        type="text"
                                                        placeholder={t('isin').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "150px" }}
                                                        value={securityData?.isin_code}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetSecurityData("isin_code", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={documentEnabled === "N"}
                                                    />
                                                </div>
                                                <div className="input-item-with-label" >
                                                    <label htmlFor="last_synced_at" className="form-input-label">
                                                        {t('Sync').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="last_synced_at"
                                                        type="date"
                                                        placeholder={t('launchDate').toUpperCase()}
                                                        className="form-input-item"
                                                        style={{ width: "150px" }}
                                                        value={securityData?.last_synced_at}
                                                        onChange={(e) => {
                                                            try {
                                                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                handleSetSecurityData("last_synced_at", formattedDate);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="input-item-with-label">
                                                    <label htmlFor="security_last_price"
                                                        className="form-input-label"
                                                        style={{ width: "max-content" }}>
                                                        {t('price').toUpperCase()}
                                                    </label>
                                                    <input
                                                        name="security_last_price"
                                                        type="text"
                                                        placeholder="0.00"
                                                        className="form-input-item"
                                                        style={{ width: "150px", textAlign: "right" }}
                                                        value={securityData?.security_last_price}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5px" }}>
                                            <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                            <span className="sub-title">{t('details').toUpperCase()}</span>

                                            <div className="row-details">
                                                <div className="row-left" >
                                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "10px", justifyContent: "space-between" }}>
                                                        <div className="input-item-with-label" >
                                                            <label htmlFor="issue_date" className="form-input-label">
                                                                {t('issuedOn').toUpperCase()}
                                                            </label>
                                                            <input
                                                                name="issue_date"
                                                                type="date"
                                                                placeholder={t('issuedOn').toUpperCase()}
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={securityData?.issue_date}
                                                                onChange={(e) => {
                                                                    try {
                                                                        const formattedDate = moment(e.target.value).format(
                                                                            "YYYY-MM-DD"
                                                                        );
                                                                        handleSetSecurityData("issue_date", formattedDate);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                        <div className="input-item-with-label" >
                                                            <label htmlFor="maturity_date" className="form-input-label">
                                                                {t('maturity').toUpperCase()}
                                                            </label>
                                                            <input
                                                                name="maturity_date"
                                                                type="date"
                                                                placeholder={t('maturity').toUpperCase()}
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={securityData?.maturity_date}
                                                                onChange={(e) => {
                                                                    try {
                                                                        const formattedDate = moment(e.target.value).format(
                                                                            "YYYY-MM-DD"
                                                                        );
                                                                        handleSetSecurityData("maturity_date", formattedDate);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "10px", justifyContent: "space-between" }}>
                                                        <div className="input-item-with-label">
                                                            <label htmlFor="face_value"
                                                                className="form-input-label"
                                                                style={{ width: "80px" }}>
                                                                {t('face').toUpperCase()}
                                                            </label>
                                                            <input
                                                                name="face_value"
                                                                type="text"
                                                                placeholder="0.00"
                                                                className="form-input-item"
                                                                style={{ width: "200px", textAlign: "right" }}
                                                                value={securityData?.face_value}
                                                                onChange={(e) => handleSetSecurityData("face_value", e.target.value)}
                                                                onBlur={(e) => {
                                                                    try {
                                                                        if (e.target.value) {
                                                                            const strippedValue = e.target.value.replace(/,/g, "");
                                                                            if (isNaN(strippedValue)) {
                                                                                setNotifyDialogTitle("Error!");
                                                                                setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            }
                                                                            handleSetSecurityData("face_value", formatAmountsToDecimals(strippedValue || 0, 6));
                                                                        }
                                                                    } catch (error) {
                                                                        console.log(error)
                                                                    }
                                                                }}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                        <div className="input-item-with-label">
                                                            <label htmlFor="coupon_rate"
                                                                className="form-input-label"
                                                                style={{ width: "max-content" }}>
                                                                {t('coupon').toUpperCase()}
                                                            </label>
                                                            <input
                                                                name="coupon_rate"
                                                                type="text"
                                                                placeholder="0.00"
                                                                className="form-input-item"
                                                                style={{ width: "200px", textAlign: "right" }}
                                                                value={securityData?.coupon_rate}
                                                                onChange={(e) => handleSetSecurityData("coupon_rate", e.target.value)}
                                                                onBlur={(e) => {
                                                                    try {
                                                                        if (e.target.value) {
                                                                            const strippedValue = e.target.value.replace(/,/g, "");
                                                                            if (isNaN(strippedValue)) {
                                                                                setNotifyDialogTitle("Error!");
                                                                                setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                setIsNotifyDialogOpen(true);
                                                                                return;
                                                                            }
                                                                            handleSetSecurityData("coupon_rate", formatAmountsToDecimals(strippedValue || 0, 6));
                                                                        }
                                                                    } catch (error) {
                                                                        console.log(error)
                                                                    }
                                                                }}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row-right" />
                                            </div>
                                        </div>
                                        <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                        <span className="sub-title">{t('issuer').toUpperCase()}</span>
                                        {selectedIssuer &&
                                            <motion.div
                                                className="entity-details-container"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                                <div className="entity-details-wrapper">
                                                    <div className="entity-details-left">
                                                        {selectedIssuer?.ent_photo_url ?
                                                            <img src={selectedIssuer?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                    </div>
                                                    <div className="entity-details-right">
                                                        <div className="name-row">
                                                            {documentEnabled === "Y" ?
                                                                <div className="input-item-with-label">
                                                                    <AsyncSelect
                                                                        id="issuer_ent"
                                                                        name="issuer_ent"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="400px"
                                                                        isClearable
                                                                        value={selectedIssuer}
                                                                        onChange={(selectedOption) => setSelectedIssuer(selectedOption)}
                                                                        loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                                        isSearchable={true}
                                                                        placeholder={t('issuer').toUpperCase()}
                                                                        noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                    />
                                                                </div>
                                                                : <span className="main-title"> {selectedIssuer?.ent_name}</span>}
                                                            <span className={`status ${selectedIssuer?.ent_status}`}>{`${t('issuer').toUpperCase()} ${t('status').toUpperCase()} ${selectedIssuer?.ent_status || ""}`}</span>
                                                        </div>
                                                        <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}>
                                                                <MdEmail className="icon" /> <span className="sub-title">{selectedIssuer?.ent_email || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                                <MdPhone className="icon" /> <span className="sub-title">{selectedIssuer?.ent_phone_no || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                                <TbCertificate className="icon" /> <span className="sub-title">{selectedIssuer?.aent_name_xx || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details"
                                                                style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                                                onClick={() => {
                                                                    try {
                                                                        navigate(`/entity/${selectedIssuer?.ent_docid}`);
                                                                    } catch (error) {
                                                                        console.log(error)
                                                                    }
                                                                }}>
                                                                <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedIssuer?.ent_code}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>}

                                        <hr className="separator-h" style={{ margin: "3px 0px" }} />
                                        <span className="sub-title">{t('exchange').toUpperCase()}</span>
                                        {selectedExchange &&
                                            <motion.div
                                                className="entity-details-container"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                                <div className="entity-details-wrapper">
                                                    <div className="entity-details-left">
                                                        {selectedExchange?.ent_photo_url ?
                                                            <img src={selectedExchange?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                    </div>
                                                    <div className="entity-details-right">
                                                        <div className="name-row">
                                                            {documentEnabled === "Y" ?
                                                                <div className="input-item-with-label">
                                                                    <AsyncSelect
                                                                        id="exchange_ent"
                                                                        name="exchange_ent"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="400px"
                                                                        isClearable
                                                                        value={selectedExchange}
                                                                        onChange={(selectedOption) => setSelectedExchange(selectedOption)}
                                                                        loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                                        isSearchable={true}
                                                                        placeholder={t('exchange').toUpperCase()}
                                                                        noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                    />
                                                                </div>
                                                                : <span className="main-title"> {selectedExchange?.ent_name}</span>}
                                                            <span className={`status ${selectedExchange?.ent_status}`}>{`${t('exchange').toUpperCase()} ${t('status').toUpperCase()} ${selectedExchange?.ent_status || ""}`}</span>
                                                        </div>
                                                        <div className="email-phone-row" style={{ display: "flex", alignCenter: "center", flexDirection: "row", width: "100%" }}>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1.8" }}>
                                                                <MdEmail className="icon" /> <span className="sub-title">{selectedExchange?.ent_email || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                                <MdPhone className="icon" /> <span className="sub-title">{selectedExchange?.ent_phone_no || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details" style={{ display: "flex", alignCenter: "center", flexDirection: "row", flex: "1" }}>
                                                                <TbCertificate className="icon" /> <span className="sub-title">{selectedExchange?.aent_name_xx || t('unspecified')}</span>
                                                            </span>
                                                            <span className="email-phone-details"
                                                                style={{ display: "flex", alignCenter: "center", flexDirection: "row", cursor: "pointer", flex: "1" }}
                                                                onClick={() => {
                                                                    try {
                                                                        navigate(`/entity/${selectedExchange?.ent_docid}`);
                                                                    } catch (error) {
                                                                        console.log(error)
                                                                    }
                                                                }}>
                                                                <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedExchange?.ent_code}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>}
                                    </ExpandableComponent>
                                </div>
                                <ExpandableComponent
                                    title={t('ratings').toUpperCase()}
                                    subtitle={
                                        documentEnabled === "Y" &&
                                        <span style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                                            <AsyncSelect
                                                ref={agencyRef}
                                                id="rating_agency"
                                                name="rating_agency"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="300px"
                                                value={selectedAgency}
                                                onChange={(selectedOption) => {
                                                    try {
                                                        setAgencyRatings([]);
                                                        setSelectedAgency(selectedOption);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                isSearchable={true}
                                                placeholder={t('agency')}
                                                noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                            />
                                            <div className="input-item-with-label">
                                                <Select
                                                    id="rate_grade"
                                                    name="rate_grade"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                        menuPortal: base => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                        })
                                                    }}
                                                    width="100px"
                                                    dropdownHeight={4 * 42}
                                                    value={selectedGrade}
                                                    onChange={(selectedOption) => {
                                                        try {
                                                            setSelectedGrade(selectedOption);
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                    options={agencyRatings}
                                                    isSearchable={true}
                                                    placeholder={t('grade')}
                                                />
                                            </div>
                                            <CircularButton currentTheme={currentTheme}
                                                onClick={async (e) => {
                                                    try {

                                                        if (!selectedAgency) {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`Please select agency`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        if (!selectedGrade) {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`Please select grade`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }

                                                        const res = await newRequest.post(
                                                            "/amsec/addRating",
                                                            {
                                                                security_docid: securityData?._id,
                                                                agency_docid: selectedAgency?.ent_docid,
                                                                agency_code: selectedAgency?.ent_code,
                                                                rating: selectedGrade?.value,
                                                            }
                                                        );

                                                        if (res.data?.msg === "added") {
                                                            setSecurityRatings((prevData) => [...prevData, res.data?.doc]);
                                                            setSelectedAgency(null);
                                                            setSelectedGrade(null);
                                                            if (agencyRef.current) {
                                                                agencyRef.current.focus();
                                                            }
                                                            showToast(t('added'), "success");
                                                        } else if (res.data?.msg === "exists") {
                                                            setSelectedAgency(null);
                                                            setSelectedGrade(null);
                                                            showToast(t('alreadyAdded'), "success");
                                                        } else {
                                                            showToast(res.data?.msg, "error");
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }} icon={<MdAdd />} width={"35px"} height={"35px"} />
                                        </span>}
                                    defaultExpanded={true}
                                >
                                    {securityRatings.length > 0 && (
                                        <div className="ratings-agency-wrapper">
                                            {securityRatings?.map((row, index) => (
                                                <div key={row?.sector} className="agency-details">
                                                    <div className="agency-left"> <span className="sub-title"> {index + 1}.</span></div>
                                                    <div className="agency-center">
                                                        {row?.agency_photo_url_xx ?
                                                            <img src={row?.agency_photo_url_xx} alt="" /> : <CiImageOn style={{ height: "30px", width: "30px" }} />}
                                                        <div style={{ display: "flex", width: "100%", flexDirection: "column", justifyContent: "flex-start" }}>
                                                            <span className="main-title">{row?.agency_name_xx}</span>
                                                            <span className="sub-title xrsmall">{row?.grade_xx} : {row?.meaning_xx}</span>
                                                        </div>
                                                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100px" }}>
                                                            <span className="main-title xrsmall">{row?.rating}</span>
                                                        </span>
                                                    </div>
                                                    {documentEnabled === "Y" &&
                                                        <div className="agency-right">
                                                            <CircularButton
                                                                currentTheme={currentTheme}
                                                                onClick={async (e) => {
                                                                    try {
                                                                        const res = await newRequest.post("/amsec/removeRating",
                                                                            {
                                                                                security_docid: securityData?._id,
                                                                                agency_docid: row?.agency_docid
                                                                            });

                                                                        if (res.data?.msg === "removed") {
                                                                            setSecurityRatings((prevData) => prevData.filter(doc => doc?.agency_docid.toString() !== row?.agency_docid.toString()));
                                                                            showToast("Removed!", "success");
                                                                        } else {
                                                                            showToast("Error remiving grade!", "error");
                                                                        }
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }} color="#E53935" icon={<MdDelete/>} width={"35px"} height={"35px"} />
                                                        </div>}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </ExpandableComponent>

                                {/* ADD MORE CONTENT HERE */}
                            </div>
                        </div>
                        <div className="summary-wrapper">
                            <div className="summary-content">
                                <div className="logo">
                                    {securityData?.sec_logo_url ?
                                        <img src={securityData?.sec_logo_url} alt="" className="logo" /> : <CiImageOn style={{ height: "120px", width: "120px" }} />}
                                    <input
                                        type="file"
                                        id="file"
                                        style={{ display: "none" }}
                                        accept="image/*"
                                        onChange={(e) => setImg(e.target.files[0])}
                                    />
                                    {securityData?.sec_status !== "Active" &&
                                        <label htmlFor="file" style={{ cursor: "pointer" }}>
                                            <span className="sub-title">{securityData?.sec_logo_url ? t('changeLogo') : t('selectLogo')}</span>
                                        </label>}
                                </div>
                                <hr className="separator-h" />
                                <h1 className="sub-title" style={{ alignSelf: "center" }}>{t('timeline').toUpperCase()}</h1>
                                <hr className="separator-h" />
                                <div className="timeline-root">
                                    {traceData.map((item) => (
                                        <div key={item?._id} className="timeline-item">
                                            <div className="timeline-separator">
                                                <div className="timeline-dot"></div>
                                                <div className="timeline-connector" />
                                            </div>
                                            <div className="timeline-content">
                                                <div className="timeline-navbar">
                                                    <div className="avatar-container">
                                                        {item?.updated_by_photo_url_xx ?
                                                            <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" /> : <CiImageOn style={{ width: "30px", height: "30px" }} />}
                                                        <span className="username">{item?.updated_by_name_xx}</span>
                                                    </div>
                                                    <span className="time-ago">{item?.time_ago_xx}</span>
                                                </div>
                                                <div className="remarks">
                                                    {item?.trc_remarks}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {validationMsgDialog && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('messages')}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setValidationMsgDialog(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <ValidationMessages messageData={validationMessagesResult} />
                        </div>
                    </div>
                </motion.div>
            )}
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={securityData?.report_keys_array}
                                documentData={{
                                    docNo: "",
                                    docType: "AM Security",
                                    docId: securityDocId,
                                }} />
                        </div>
                    </div>
                </motion.div>)}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
            {/* progress dialog for file upload  */}
            <UploadDialog
                open={isDialogOpen}
                handleClose={() => setIsDialogOpen(false)}
                uploadProgress={uploadProgress}
            />
        </motion.div >
    )
};

export default AmSecurity